/**
 * AppLayout Component
 * Main layout wrapper for authenticated pages
 * Combines Sidebar, Header, and content area
 */

import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import styles from './AppLayout.module.css';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <div className={styles.appLayout}>
      {/* Fixed Sidebar */}
      <Sidebar />

      {/* Fixed Header */}
      <Header />

      {/* Main Content Area */}
      <main className={styles.mainContent}>
        <div className={styles.contentWrapper}>
          {children}
        </div>
      </main>
    </div>
  );
};
